import { css } from '@emotion/css';
import { Color } from 'css/theme';
import * as React from 'react';
import { FieldError } from 'react-hook-form';

import FormInputError from './FormInputError';

interface Props {
  children: (label: string, errorClassName: string) => React.ReactNode;
  error: FieldError;
  label: string;
  labelVisible?: boolean;
  className?: string;
}

const errorContainer = css({
  borderColor: `${Color.Error} !important`,
});

const FormControlWrapper = ({ labelVisible, children, error, label, className = '' }: Props) => {
  const errorStr = error?.message;
  return (
    <div className={className}>
      <div className="inputContainer">
        {children(label, !!errorStr ? errorContainer : '')}
        <label {...(labelVisible !== undefined ? { className: labelVisible ? 'labelText' : 'labelTextHidden' } : {})}>
          {label}
        </label>
      </div>
      <FormInputError error={errorStr} />
    </div>
  );
};

export default FormControlWrapper;
